module.exports = __webpack_public_path__ + "static/media/combat(23).ac62141a.PNG";